import React from "react";

export function useGlassTube() {
  function drawGlassTube(props) {
    const TUBE_ITEMS = [];
    if (hasItem(props.boxId)) {
      TUBE_ITEMS.push(
        <path key="0" d="M6 0H57V182.405H6V0Z" fill="#7D5624" />,
        <path key="1" d="M0 11L6 0V182.405L0 191V11Z" fill="#573101" />,
        <path key="2" d="M62 11L57 0V182.405L62 191L62 11Z" fill="#573101" />
      );
    }
    TUBE_ITEMS.push(
      <path
        key="3"
        d="M14.8955 34H46.6731V176C46.6731 182.627 41.3379 188 34.7565 188H26.8121C20.2308 188 14.8955 182.627 14.8955 176V34Z"
        fill="#99B2C4"
      />,
      <path
        key="4"
        d="M16.8818 34H44.6873V174C44.6873 179.523 40.2412 184 34.7568 184H26.8123C21.3279 184 16.8818 179.523 16.8818 174V34Z"
        fill="#CCD8E1"
      />,
      <rect
        key="5"
        x="11.9165"
        y="30"
        width="37.7359"
        height="4"
        rx="2"
        fill="#99B2C4"
      />,
      <rect
        key="6"
        opacity="0.2"
        x="39.7222"
        y="30"
        width="9.93051"
        height="4"
        rx="2"
        fill="#333333"
      />
    );
    if (props.solution) {
      TUBE_ITEMS.push(
        <path
          key="7"
          d="M16.8818 48H44.6873V174C44.6873 179.523 40.2412 184 34.7568 184H26.8123C21.3279 184 16.8818 179.523 16.8818 174V48Z"
          fill={props.solution}
        />
      );
    }
    TUBE_ITEMS.push(
      <path
        key="8"
        opacity="0.2"
        d="M15.2598 178.956C16.5673 184.154 21.2437 188 26.8122 188H34.7566C41.3379 188 46.6732 182.627 46.6732 176V34H41.7079V167C41.7079 175.837 34.5943 183 25.8191 183C21.7657 183 18.0668 181.472 15.2598 178.956Z"
        fill="#333333"
      />
    );
    if (hasItem(props.stopperId)) {
      TUBE_ITEMS.push(
        <path
          key="9"
          d="M14.8955 18H46.6731L44.687 30V38H16.8816V30L14.8955 18Z"
          fill="#DA9038"
        />,
        <path
          key="10"
          d="M42.7009 18H46.6731L44.687 30V38H40.7148V30L42.7009 18Z"
          fill="#C47519"
        />,
        <path
          key="11"
          d="M18.8679 18H14.8957L16.8818 30V38H20.854V30L18.8679 18Z"
          fill="#F0B168"
        />,
        <rect
          key="12"
          x="16.8818"
          y="30"
          width="24.8263"
          height="4"
          fill="#99B2C4"
        />,
        <path
          key="13"
          d="M38.729 32C38.729 30.8954 39.6244 30 40.729 30H44.6873V34H40.729C39.6244 34 38.729 33.1046 38.729 32Z"
          fill="#8599A7"
        />
      );
    }
    if (hasItem(props.plantId)) {
      TUBE_ITEMS.push(
        <g key="14">
          <path
            d="M31.2862 81.7506C29.9944 91.9916 26.9709 102.609 30.3966 112.272C31.4331 115.226 33.113 118.076 33.8885 121.167C35.1564 126.166 34.0197 131.461 32.5337 136.339C31.0624 141.31 29.1021 146.171 28.6861 151.254C28.1669 158.058 30.3575 164.704 30.603 171.572C31.2246 172.5 34.2132 172.496 34.0263 169.975C33.4528 168.743 32.7875 167.527 32.306 166.28C28.7074 157.307 31.4368 147.211 33.916 137.913C36.3952 128.614 36.8043 119.936 32.3306 111.39C31.2719 109.48 30.923 106.698 30.6622 104.469C30.3867 102.148 30.9163 100.737 31.0635 99.2937C31.2808 96.514 31.6672 93.6123 31.9764 90.8177C32.9258 83.7552 34.2907 76.3413 31.8243 69.7396C30.6665 66.6157 28.6226 63.2574 29.9282 60.2062C28.8506 63.5042 28.8575 67.0991 29.7689 70.4523C30.2614 72.3595 31.1363 74.2991 31.4449 76.2362C31.6469 78.096 31.4665 79.9233 31.2862 81.7506Z"
            fill="#22CE22"
          />
          <path
            d="M30.9655 99.4023C31.1828 96.6226 31.5694 93.7207 31.8786 90.9261C32.8284 83.8634 34.1938 76.4492 31.7266 69.8473C30.9434 67.8926 29.9615 65.8756 29.5461 63.8612C29.5608 63.9534 29.4836 64.0606 29.4983 64.1528C29.4317 67.2866 30.2884 69.7025 31.4026 72.5497C32.2299 74.7811 32.2481 76.6709 32.3839 79.2985C32.4865 82.3102 32.008 85.227 31.6215 88.1288C30.981 92.3968 29.6706 100.748 29.788 103.852C29.8241 109.998 33.6009 115.346 34.6191 121.142C35.549 126.385 34.4929 131.005 33.6316 136.255C33.5984 136.639 33.4327 138.559 33.5209 139.112C33.646 138.713 33.7711 138.314 33.8043 137.93C36.2844 128.632 36.6937 119.953 32.2184 111.407C31.1593 109.497 30.8102 106.714 30.5493 104.486C30.1964 102.272 30.8182 100.846 30.9655 99.4023Z"
            fill="#65E63C"
          />
          <path
            d="M29.9133 51.5872C30.4346 53.6786 30.9559 55.77 31.0034 57.8439C31.0656 60.01 30.5622 62.1735 29.3278 63.8882C29.4125 62.6444 28.7624 61.5201 28.2961 60.366C27.8298 59.2118 27.5471 58.0278 27.3562 56.8288C27.2828 56.3677 27.2241 55.9988 27.349 55.6C27.7569 54.0197 29.9792 53.185 29.9133 51.5872Z"
            fill="#65E63C"
          />
          <path
            d="M29.2305 62.6743C30.1825 59.7754 29.0179 57.7884 28.9923 57.0356C28.9373 56.0983 29.4041 54.8869 29.2572 53.9645C29.2278 53.7801 29.1838 53.5034 29.1544 53.3189C28.5076 53.9919 27.6771 54.6947 27.5337 55.5696C27.4087 55.9685 27.4821 56.4297 27.5409 56.7986C27.7318 57.9977 28.0146 59.1818 28.4812 60.336C28.7052 61.1512 29.0211 61.9514 29.2305 62.6743Z"
            fill="#34CE1D"
          />
          <path
            d="M38.2328 58.9463C37.8069 63.3652 34.6815 67.3728 30.61 68.9813C30.8155 67.9078 31.0981 66.7271 31.3036 65.6535C31.399 65.0706 31.5715 64.3806 31.865 63.8601C32.6391 62.2211 34.2787 61.2922 35.8266 60.3782C36.5932 59.8752 37.4515 59.3572 38.2328 58.9463Z"
            fill="#65E63C"
          />
          <path
            d="M35.8594 62.359C34.8763 63.2755 33.6035 64.1447 33.0459 65.3702C32.3965 66.6106 31.8242 67.7439 31.1309 68.7078C34.8208 67.0668 37.5464 63.5026 38.2291 59.5147C37.5504 60.5708 36.7654 61.5496 35.8594 62.359Z"
            fill="#34CE1D"
          />
          <path
            d="M38.446 72.0697C39.9751 71.6317 41.6252 71.363 42.685 70.3398C43.1029 71.7841 43.55 73.4126 43.0219 74.8219C42.3983 76.8139 40.2384 78.0162 38.1592 78.5438C36.08 79.0714 33.9276 79.1383 31.9987 80.0195C32.2959 78.9314 32.593 77.8433 32.8902 76.7552C33.0772 76.1576 33.1727 75.575 33.4661 75.0546C33.8365 74.4271 34.5112 73.9392 35.2006 73.5434C36.2274 72.9036 37.3752 72.4331 38.446 72.0697Z"
            fill="#65E63C"
          />
          <path
            d="M42.7759 70.3248C41.9614 71.1194 40.982 71.468 39.8961 71.7394C42.9955 74.0717 39.7378 77.2501 37.4376 78.7595C37.7128 78.7147 37.9879 78.6699 38.3547 78.6101C40.4346 78.0823 42.61 76.9715 43.2192 74.8864C43.6412 73.3992 43.1939 71.7698 42.7759 70.3248Z"
            fill="#B9F237"
          />
          <path
            d="M37.1113 75.5013C34.8197 75.8744 33.2208 77.6469 32.1243 79.621L31.9996 80.0194C33.9283 79.1383 36.1723 79.0565 38.1596 78.5439C40.2386 78.0164 42.4131 76.9063 43.022 74.8225C43.4107 73.7196 43.2056 72.4299 42.9234 71.2472C42.4941 73.8688 40.1363 75.0088 37.1113 75.5013Z"
            fill="#34CE1D"
          />
          <path
            d="M17.3075 66.8835C17.5348 67.1301 17.8391 67.2695 18.1434 67.409C20.8237 68.2958 23.7902 67.4347 26.6428 67.6319C27.6952 67.7441 28.7622 67.9484 29.7668 68.3519C30.0639 67.2639 29.4921 66.0338 28.6268 65.324C27.8386 64.5072 26.7422 64.1187 25.723 63.623C23.82 62.8932 21.8108 62.0862 19.8857 62.3996C19.244 62.5041 18.5253 62.7157 18.0339 63.1737C17.2968 63.8608 17.0144 65.041 17.0839 66.0693C17.0362 66.3606 17.0802 66.637 17.3075 66.8835Z"
            fill="#65E63C"
          />
          <path
            d="M27.4863 67.0221C26.1627 66.3871 25.0335 66.382 23.5999 66.2374C21.587 65.9981 18.9656 65.4799 17.5725 63.8167C17.2022 64.444 17.059 65.3178 17.0846 66.0696C17.1286 66.346 17.1726 66.6223 17.2935 66.7916C17.5208 67.0381 17.8251 67.1776 18.1294 67.317C20.8095 68.2037 23.7758 67.3427 26.6282 67.5398C27.5742 67.5748 28.4578 67.809 29.356 68.1352C28.7327 67.7642 28.1095 67.3932 27.4863 67.0221Z"
            fill="#34CE1D"
          />
          <path
            d="M41.9988 83.7009C39.1351 87.5682 34.8601 90.2481 30.1233 91.2081C30.7907 89.4934 32.1584 88.0426 33.6763 86.9452C35.1942 85.8478 36.9541 85.089 38.7285 84.4222C39.7074 84.0739 40.8697 83.6958 41.9988 83.7009Z"
            fill="#65E63C"
          />
          <path
            d="M35.9323 87.5246C34.4036 87.9623 33.2817 89.1839 32.1305 90.2213C31.8848 90.4502 31.5476 90.694 31.3019 90.9229C34.374 90.1396 37.2226 88.5425 39.5104 86.3756C38.3629 86.8457 37.1091 87.2386 35.9323 87.5246Z"
            fill="#34CE1D"
          />
          <path
            d="M23.0386 92.1636C25.9503 92.7294 28.5909 90.4086 31.5248 89.9309C31.0554 89.3456 30.5091 88.8673 29.8857 88.4961C28.5033 87.4922 27.2125 86.4734 25.8301 85.4696C24.7667 84.6974 23.6886 83.833 22.3941 83.382C21.2977 82.9933 20.0618 82.911 19.1266 83.536C18.1914 84.1609 17.6631 85.5705 18.3745 86.4946C18.6018 86.7412 18.8292 86.9878 19.0565 87.2343C20.0429 88.1136 20.5378 89.4511 21.1868 90.5744C21.4581 91.0975 21.8211 91.6056 22.2465 91.9145C22.4591 92.0689 22.7489 92.1163 23.0386 92.1636Z"
            fill="#65E63C"
          />
          <path
            d="M29.2336 87.9419C29.1566 88.0489 29.065 88.0638 28.8963 88.1858C26.8427 89.4654 24.1256 89.5297 21.966 88.3691C20.5214 87.5646 19.3078 86.439 18.0172 85.4204C17.9842 85.8038 18.0428 86.1723 18.2848 86.511C18.5121 86.7576 18.7394 87.0041 18.9667 87.2506C19.953 88.1298 20.4479 89.4669 21.0968 90.59C21.368 91.113 21.731 91.621 22.1563 91.9298C22.369 92.0842 22.6586 92.1316 22.963 92.271C25.8743 92.8367 28.5147 90.5164 31.4481 90.0388C30.9789 89.4535 30.4326 88.9754 29.8093 88.6043C29.6736 88.3428 29.461 88.1884 29.2336 87.9419Z"
            fill="#34CE1D"
          />
          <path
            d="M43.1754 94.5819C43.52 95.5654 42.7352 96.5437 41.8771 97.0614C39.9777 98.1268 37.5541 97.6708 35.6547 98.7361C33.495 99.9383 32.391 103.048 29.9306 103.543C29.5237 102.759 29.3772 101.837 29.6266 101.041C29.7366 100.55 29.953 100.137 30.1694 99.7237C32.2084 95.9894 36.4216 93.5078 40.6492 93.481C41.5806 93.4239 42.8455 93.6905 43.1754 94.5819Z"
            fill="#65E63C"
          />
          <path
            d="M43.1711 94.5824C42.8265 93.5984 41.6675 93.4089 40.6295 93.3889C39.8813 93.4162 39.2394 93.5207 38.5059 93.6401C38.8103 93.7797 39.1293 94.0114 39.3714 94.3502C40.2185 95.536 40.0423 96.7939 39.349 97.7578C40.2659 97.6085 41.0912 97.4741 41.8725 97.0632C42.7308 96.5452 43.5158 95.5664 43.1711 94.5824Z"
            fill="#B9F237"
          />
          <path
            d="M43.175 94.5843C41.9651 95.2537 40.5279 95.6766 38.757 95.7759C34.2072 96.1387 32.5349 99.8124 30.4521 103.27C32.5933 102.543 33.6641 99.8176 35.732 98.6305C37.6313 97.5655 40.0546 98.0213 41.9539 96.9563C42.7349 96.5457 43.5196 95.5675 43.175 94.5843Z"
            fill="#34CE1D"
          />
          <path
            d="M26.0681 102.271C27.2745 102.17 28.4662 101.976 29.614 101.505C26.7175 98.6685 22.6988 97.0543 18.6396 96.9591C19.3472 98.4508 20.5754 99.6686 21.8807 100.779C22.3207 101.18 22.7606 101.581 23.263 101.783C24.099 102.309 25.1367 102.329 26.0681 102.271Z"
            fill="#65E63C"
          />
          <path
            d="M23.687 97.9301C22.0879 97.3394 20.3493 97.0552 18.6548 97.0475C19.3625 98.5397 20.5911 99.758 21.8967 100.869C22.0178 101.039 22.2158 101.101 22.3369 101.27C21.5814 100.07 22.3262 98.2462 23.687 97.9301Z"
            fill="#B9F237"
          />
          <path
            d="M23.6265 99.9282C22.0608 98.9543 20.2494 98.2095 18.8378 97.0214L18.7461 97.0364C19.4536 98.5281 20.6819 99.746 21.9873 100.857C22.4273 101.258 22.8672 101.659 23.3696 101.861C24.191 102.294 25.2434 102.406 26.1748 102.349C27.1979 102.277 28.1 102.036 29.0937 101.779C27.1099 101.724 25.2985 100.979 23.6265 99.9282Z"
            fill="#34CE1D"
          />
          <path
            d="M43.4283 106.752C44.2166 107.569 43.9781 109.025 43.1639 109.82C42.3644 110.706 41.2936 111.07 40.2375 111.525C37.8648 112.573 35.6277 113.883 33.618 115.439C33.9151 114.351 33.8309 113.23 33.9301 112.08C34.2347 109.856 35.7898 107.807 37.8104 106.91C38.6062 106.592 39.5083 106.35 40.3334 106.216C41.4335 106.037 42.64 105.935 43.4283 106.752Z"
            fill="#65E63C"
          />
          <path
            d="M43.4252 106.752C42.6511 106.027 41.4293 106.037 40.4349 106.293C40.3431 106.308 40.2514 106.323 40.1597 106.338C41.3778 106.897 42.3023 107.976 42.0159 109.725C41.9204 110.308 41.7039 110.721 41.3956 111.15C42.1002 110.846 42.79 110.45 43.2671 109.899C43.8836 109.042 44.1223 107.585 43.4252 106.752Z"
            fill="#B9F237"
          />
          <path
            d="M42.6878 108.008C41.0156 109.32 38.9219 109.755 37.2497 111.067C35.7462 112.257 34.8368 113.634 33.7586 115.133C33.6816 115.24 33.7109 115.424 33.6339 115.531C35.6434 113.975 37.8802 112.666 40.2527 111.618C41.3087 111.162 42.3648 110.707 43.1789 109.913C43.9013 109.134 44.1691 107.861 43.5789 107.107C43.3332 107.336 43.0105 107.672 42.6878 108.008Z"
            fill="#34CE1D"
          />
          <path
            d="M21.236 114.988C23.6338 117.055 27.2786 117.502 30.1572 116.088C30.9383 115.677 31.7047 115.174 32.3648 114.594C32.7021 114.35 33.1165 113.999 32.9516 113.553C32.9369 113.461 32.8159 113.292 32.7096 113.215C31.1477 111.673 29.3401 110.361 27.3455 109.646C25.2591 108.946 22.8317 109.057 21.0532 110.292C20.5471 110.658 20.1474 111.101 19.9456 111.607C19.4945 112.909 20.2644 114.201 21.236 114.988Z"
            fill="#65E63C"
          />
          <path
            d="M23.9068 112.851C23.6869 111.468 24.2922 109.951 25.7007 109.344L25.7924 109.329C24.1603 109.122 22.4182 109.406 21.0684 110.382C20.5622 110.748 20.1624 111.191 19.9606 111.697C19.5864 112.892 20.3418 114.093 21.2219 114.895C23.5139 116.886 26.8844 117.377 29.6242 116.269C27.2586 116.181 24.2402 115.538 23.9068 112.851Z"
            fill="#B9F237"
          />
          <path
            d="M32.3654 114.594C30.3047 114.646 28.2109 115.082 26.187 114.183C24.1777 113.376 22.3849 112.155 20.8854 110.415C20.471 110.766 20.0713 111.209 19.8695 111.714C19.4954 112.909 20.2506 114.11 21.1305 114.911C23.5283 116.978 27.173 117.425 30.0515 116.011C30.9389 115.677 31.6137 115.189 32.3654 114.594Z"
            fill="#34CE1D"
          />
          <path
            d="M40.1241 120.487C40.3724 120.356 40.6067 120.138 40.8551 120.007C41.6595 119.426 42.8276 118.875 43.6389 119.464C44.2473 119.906 44.2997 120.799 44.2367 121.53C41.631 123.757 38.4624 125.265 35.1959 126.157C35.7802 123.628 38.0326 121.999 40.1241 120.487Z"
            fill="#65E63C"
          />
          <path
            d="M43.637 119.464C42.8254 118.875 41.6568 119.426 40.852 120.008C40.852 120.008 40.852 120.008 40.7646 120.022C41.7511 120.583 42.3982 121.831 41.5024 122.969C41.282 123.275 40.9741 123.596 40.7396 123.815C41.9817 123.161 43.1084 122.347 44.1476 121.546C44.2981 120.8 44.2457 119.907 43.637 119.464Z"
            fill="#B9F237"
          />
          <path
            d="M40.7445 123.814C39.5488 124.189 38.4126 124.374 37.161 124.397C36.6226 124.395 36.1121 124.568 35.6157 124.829C35.4093 125.222 35.217 125.704 35.0247 126.185C37.1818 125.654 39.1956 124.787 41.1675 123.655C41.0801 123.67 40.9053 123.698 40.7445 123.814Z"
            fill="#34CE1D"
          />
          <path
            d="M35.3757 124.613C34.9358 124.213 34.3419 124.026 33.7626 123.931C30.7014 123.012 27.6071 122.477 24.3734 122.247C24.1533 123.228 25.0331 124.029 25.869 124.555C26.4922 124.926 27.0238 125.312 27.6617 125.775C27.9806 126.006 28.3912 126.223 28.7872 126.347C29.5791 126.596 30.404 126.462 31.2143 126.236C32.6515 125.813 34.0741 125.298 35.3757 124.613Z"
            fill="#34CE1D"
          />
          <path
            d="M41.4032 133.486C39.4741 136.73 36.511 139.387 32.976 140.813C32.5323 140.98 31.9969 141.161 31.5863 140.945C33.3651 137.347 36.4676 134.384 40.1566 132.744C40.4169 132.607 40.6773 132.47 40.967 132.517C41.2566 132.565 41.5756 132.796 41.5279 133.088C41.6342 133.165 41.4802 133.379 41.4032 133.486Z"
            fill="#65E63C"
          />
          <path
            d="M41.4032 133.486C39.4741 136.73 36.511 139.387 32.976 140.813C32.5323 140.98 31.9969 141.161 31.5863 140.945C33.3651 137.347 36.4676 134.384 40.1566 132.744C40.4169 132.607 40.6773 132.47 40.967 132.517C41.2566 132.565 41.5756 132.796 41.5279 133.088C41.6342 133.165 41.4802 133.379 41.4032 133.486Z"
            fill="#34CE1D"
          />
          <path
            d="M24.4485 130.941C23.8651 131.415 23.7219 132.289 23.7475 133.042C23.8427 134.823 24.8697 136.547 26.359 137.629C27.1954 138.155 28.0941 138.481 28.7764 139.221C29.2166 139.622 29.488 140.146 30.0052 140.44C30.4307 140.749 31.1167 140.921 31.6377 140.647C31.8065 140.525 31.9606 140.31 32.1147 140.096C33.01 138.626 33.7549 136.803 33.1241 135.203C32.5373 133.88 31.1983 133.152 29.9658 132.502C29.2505 132.146 28.4287 131.712 27.7134 131.355C26.5726 130.69 25.2776 130.239 24.4485 130.941Z"
            fill="#65E63C"
          />
          <path
            d="M28.5369 136.516C27.2158 135.312 27.8399 133.319 29.0658 132.741C28.9301 132.479 28.8861 132.202 28.9338 131.911C28.5228 131.694 28.02 131.492 27.6089 131.275C26.5887 130.779 25.2785 130.236 24.3572 130.953C23.7736 131.427 23.6304 132.301 23.656 133.054C23.7512 134.836 24.7787 136.56 26.2686 137.642C27.1053 138.168 28.0045 138.495 28.6871 139.235C29.0063 139.467 29.2485 139.806 29.5825 140.13C29.4688 138.824 29.2965 137.149 28.5369 136.516Z"
            fill="#B9F237"
          />
          <path
            d="M32.3032 139.498C29.6104 137.95 28.9467 134.37 26.1621 132.837C25.432 132.388 24.702 131.94 23.9719 131.491C23.7554 131.905 23.6599 132.488 23.7479 133.041C23.8431 134.822 24.8702 136.547 26.3597 137.628C27.1961 138.154 28.095 138.481 28.7774 139.221C29.2176 139.622 29.489 140.145 30.0063 140.439C30.4319 140.749 31.118 140.921 31.639 140.647C31.8078 140.524 31.9619 140.31 32.116 140.096C32.1638 139.804 32.2408 139.697 32.3032 139.498Z"
            fill="#34CE1D"
          />
          <path
            d="M37.452 144.067C37.9102 143.992 38.4601 143.903 38.8707 144.119C39.7982 144.63 39.8493 146.133 39.127 146.911C38.4047 147.69 37.3195 147.961 36.2197 148.14C34.1264 148.576 32.0184 148.919 29.925 149.354C31.5604 146.632 34.3505 144.666 37.452 144.067Z"
            fill="#65E63C"
          />
          <path
            d="M38.9768 144.197C37.8549 145.419 36.1867 146.163 34.4747 146.63C34.2914 146.66 32.7772 147.19 33.5728 146.871C32.8689 147.175 32.3336 147.357 31.857 147.906C31.4573 148.349 31.1494 148.777 30.7497 149.22C32.5681 148.83 34.4011 148.531 36.1279 148.156C37.2277 147.977 38.3128 147.706 39.0351 146.927C39.7574 146.148 39.8126 144.722 38.9768 144.197Z"
            fill="#34CE1D"
          />
          <path
            d="M26.1934 74.8109C25.7974 74.6863 25.3098 74.5767 24.8368 74.5592C22.8092 74.2278 20.7669 73.8042 18.7393 73.4728C20.235 75.781 22.035 78.2288 24.686 78.9313C25.4779 79.1804 26.3323 79.2303 27.0803 79.203C28.9723 79.273 30.8642 79.343 32.6536 78.7681C30.9415 76.8731 28.738 75.4362 26.1934 74.8109Z"
            fill="#65E63C"
          />
          <path
            d="M27.6163 76.6588C24.4337 75.5703 21.625 75.6496 19.0732 73.7968C20.5543 76.0129 22.2188 78.1992 24.6863 78.9316C25.4783 79.1807 26.3326 79.2306 27.0807 79.2034C28.7893 79.3032 30.5896 79.3881 32.1957 78.8431C30.6741 78.1457 29.2149 77.2491 27.6163 76.6588Z"
            fill="#34CE1D"
          />
        </g>
      );
    }
    if (hasItem(props.snailId)) {
      TUBE_ITEMS.push(
        <g key="15" clipPath="url(#clip1)">
          <path
            d="M21.8943 169.919C21.873 169.919 21.8515 169.918 21.8298 169.914C21.6383 169.878 21.512 169.693 21.5475 169.5L22.3971 164.887C22.4326 164.694 22.6158 164.568 22.8078 164.603C22.9993 164.639 23.1256 164.824 23.0902 165.016L22.2405 169.629C22.209 169.8 22.0609 169.919 21.8943 169.919Z"
            fill="#D2A582"
          />
          <path
            d="M20.7826 169.919C20.6162 169.919 20.4682 169.8 20.4366 169.63L19.5783 165.017C19.5425 164.824 19.6685 164.639 19.8598 164.603C20.0512 164.566 20.2354 164.694 20.2711 164.886L21.1293 169.499C21.1651 169.692 21.0391 169.877 20.8478 169.913C20.8259 169.917 20.8041 169.919 20.7826 169.919Z"
            fill="#D2A582"
          />
          <path
            d="M39.7034 182.488L37.8958 181.274L24.1095 177.06C23.5018 176.686 23.0962 176.012 23.0962 175.242V170.629C23.0962 169.649 22.3074 168.855 21.3343 168.855H19.9248C19.341 168.855 18.8677 169.331 18.8677 169.919V170.274C18.8677 171.201 19.4565 171.987 20.2772 172.279V176.661C20.2772 180.581 23.4324 183.758 27.3246 183.758H39.3214C39.7018 183.758 40.0101 183.447 40.0101 183.065C40.0101 182.833 39.895 182.616 39.7034 182.488Z"
            fill="#E0C7A0"
          />
          <path
            d="M22.7438 165.661C23.133 165.661 23.4485 165.344 23.4485 164.952C23.4485 164.56 23.133 164.242 22.7438 164.242C22.3546 164.242 22.0391 164.56 22.0391 164.952C22.0391 165.344 22.3546 165.661 22.7438 165.661Z"
            fill="#AF6853"
          />
          <path
            d="M22.8906 165.151C23.055 165.151 23.1884 165.017 23.1884 164.851C23.1884 164.686 23.055 164.552 22.8906 164.552C22.7261 164.552 22.5928 164.686 22.5928 164.851C22.5928 165.017 22.7261 165.151 22.8906 165.151Z"
            fill="#D79885"
          />
          <path
            d="M19.925 165.661C20.3142 165.661 20.6297 165.344 20.6297 164.952C20.6297 164.56 20.3142 164.242 19.925 164.242C19.5357 164.242 19.2202 164.56 19.2202 164.952C19.2202 165.344 19.5357 165.661 19.925 165.661Z"
            fill="#AF6853"
          />
          <path
            d="M20.0244 165.151C20.1888 165.151 20.3222 165.017 20.3222 164.851C20.3222 164.686 20.1888 164.552 20.0244 164.552C19.8599 164.552 19.7266 164.686 19.7266 164.851C19.7266 165.017 19.8599 165.151 20.0244 165.151Z"
            fill="#D79885"
          />
          <path
            d="M38.6006 183.048H34.3136H28.7341C24.8419 183.048 21.6867 179.871 21.6867 175.952V172.497C21.6867 172.236 21.5386 172.006 21.3154 171.873C20.6942 171.503 20.2772 170.823 20.2772 170.043V168.855H19.9248C19.341 168.855 18.8677 169.331 18.8677 169.919V170.274C18.8677 171.201 19.4565 171.987 20.2772 172.279V176.661C20.2772 180.581 23.4324 183.758 27.3246 183.758H38.6005C38.7952 183.758 38.9529 183.599 38.9529 183.403C38.9529 183.207 38.7952 183.048 38.6006 183.048Z"
            fill="#D5A871"
          />
          <path
            d="M32.7133 167.835C27.1894 167.835 23.7351 172.35 24.1941 177.398C24.3215 178.799 26.1662 181.816 29.8393 179.684C30.7138 181.266 32.388 182.339 34.3136 182.339C37.8489 182.339 40.7148 179.453 40.7148 175.893C40.7148 171.443 37.1324 167.835 32.7133 167.835Z"
            fill="#D79885"
          />
          <path
            d="M26.3083 178.417C25.8494 173.369 29.3037 168.855 34.8276 168.855C35.649 168.855 36.4413 168.98 37.1873 169.211C35.9102 168.342 34.3706 167.835 32.7133 167.835C27.1894 167.835 23.7351 172.35 24.1941 177.397C24.2872 178.422 25.2992 180.307 27.2708 180.416C26.678 179.775 26.3586 178.97 26.3083 178.417Z"
            fill="#AF6853"
          />
          <path
            d="M36.8457 176.357C36.8457 174.341 35.2173 172.701 33.2158 172.701C31.6912 172.701 30.1657 173.618 29.3293 175.036C28.8207 175.898 28.1847 177.638 29.2112 180.006C29.4142 179.915 29.6229 179.81 29.8384 179.684C29.1802 178.132 29.2088 176.63 29.9353 175.398C30.6363 174.21 31.9546 173.411 33.2158 173.411C34.8286 173.411 36.1409 174.733 36.1409 176.357C36.1409 177.617 35.1228 178.642 33.8713 178.642C32.909 178.642 32.1261 177.854 32.1261 176.885C32.1261 176.046 32.7255 175.62 33.2825 175.579C33.7682 175.544 34.3288 175.792 34.4456 176.598C34.4735 176.792 34.6535 176.926 34.8451 176.898C35.0377 176.87 35.171 176.689 35.1428 176.495C34.968 175.29 34.058 174.811 33.2314 174.871C32.3319 174.937 31.4214 175.65 31.4214 176.885C31.4214 178.245 32.5205 179.352 33.8713 179.352C35.5114 179.352 36.8457 178.008 36.8457 176.357Z"
            fill="#AF6853"
          />
          <path
            d="M20.9821 172.43C20.7313 172.43 20.4936 172.375 20.2773 172.28V173.035C20.5009 173.102 20.7371 173.14 20.9821 173.14C21.1767 173.14 21.3345 172.981 21.3345 172.785C21.3345 172.589 21.1767 172.43 20.9821 172.43Z"
            fill="#D2A582"
          />
        </g>
      );
    }
    if (props.tubeLabel) {
      TUBE_ITEMS.push(
        <rect
          key="16"
          x="15.8892"
          y="82"
          width="26.8124"
          height="36"
          fill="white"
        />,
        <rect
          key="17"
          x="42.7012"
          y="82"
          width="2.97915"
          height="36"
          fill="#EEEEEE"
        />,
        <rect
          key="18"
          x="45.6807"
          y="82"
          width="1.9861"
          height="36"
          fill="#CCCCCC"
        />,
        <rect
          key="19"
          x="13.9028"
          y="82"
          width="1.9861"
          height="36"
          fill="#CCCCCC"
        />,
        <text
          key="20"
          x="25.5"
          y="102"
          z="1000"
          fill="#000"
          fontSize="14x"
          fontFamily="sans-serif"
          alignmentBaseline="middle"
        >
          {props.tubeLabel}
        </text>
      );
    }
    if (hasItem(props.boxId)) {
      TUBE_ITEMS.push(
        <rect
          key="21"
          y="11"
          width="62"
          height="180"
          fill="black"
          fillOpacity="0.2"
        />,
        <path key="22" d="M5.88922 0H57L62 11H0L5.88922 0Z" fill="#AF7832" />,
        <path key="23" opacity="0.1" d="M47 0H57L62 11H51L47 0Z" fill="black" />
      );
    }

    return (
      <svg
        width="62"
        height="191"
        viewBox="0 0 62 191"
        fill="none"
        role="img"
        aria-labelledby={"glass_tube_" + props.id + "_image_title"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <title id={"glass_tube_" + props.id + "_image_title"}>
          {`Tube with ${getSolutionColourName(props.solution)} BTB solution. It has ${hasItem(props.plantId) ? 1 : 0} water plants in it.`}
        </title>
        {TUBE_ITEMS}
      </svg>
    );
  }

  function getSolutionColourName(solution) {
    switch (solution) {
      case "rgb(85, 119, 54)":
        return "green";

      case "rgb(209, 185, 61)":
        return "yellow";

      case "rgb(3, 31, 92)":
        return "blue";

      default:
        return "unknown";
    }
  }

  return { drawGlassTube };
}

export function hasItem(itemId) {
  return typeof itemId === "number" && itemId >= 0;
}
